import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as routeBound from '../../route-bound'

import * as me from '../../me'

import { Api } from './api.service'
import type { TypeParams } from './types'

@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: exclusionLabel => exclusionLabel.id,
      name: ec.Name.Predefined.RateExclusionLabel,
      plugins: {
        additionalFactories: [
          new ds.input.select.singleEc.ec.Factory<TypeParams>({
            createCustom: {
              fromLabel: label => ({ name: label }),
            },
            getItem: ({ id, name }) => ({
              label: name,
              value: id,
            }),
          }),
        ],
      },
    })
  }
}
